import React, { useState, useEffect } from "react";
import Layout from "../../../../component/layout/Layout";
import "aos/dist/aos.css";
import AOS from "aos";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import firebaseConfig from "../../../firebase/firebaseConfig";
import "./SPaper.css";

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const SPaper = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [cards, setCards] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const snapshot = await db.collection("paperpulp-specialtyChemicals").orderBy("orderID").get();
        const fetchedCards = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCards(fetchedCards);
      } catch (error) {
        console.error("Error fetching cards:", error);
      }
    };

    fetchCards();
  }, []);

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  return (
    <Layout>
      <div className="bread">
        <ul className="collapsed">
          <li>
            <a href="/specialalitychem">Speciality Chemicals</a>
          </li>
          <li>
            <a href="/spaper">Paper</a>
          </li>
        </ul>
      </div>
      <section id="hero">
        <div
          id="heroCarousel"
          className="carousel slide carousel-fade"
          data-bs-interval="5000"
          data-bs-ride="carousel"
        >
          <ol className="carousel-indicators" id="hero-carousel-indicators">
            <li
              data-bs-target="#heroCarousel"
              data-bs-slide-to="0"
              className={activeSlide === 0 ? "active" : ""}
              onClick={() => handleSlideChange(0)}
            ></li>
          </ol>
          <div className="carousel-inner" role="listbox">
            <div
              className={`carousel-item ${activeSlide === 0 ? "active" : ""}`}
              style={{ backgroundImage: "url(/img/paper-pulp-1024x578.jpg)" }}
            >
              <div className="carousel-container">
                <div className="container">
                  <div className="text" id="text">
                    <h2 className="animate__animated animate__fadeInDown">Paper & Pulp</h2>
                    <p className="animate__animated animate__fadeInUp">
                      We have unique expertise in chemical producing to create the ultimate
                      papermaking process. Through our chemistry, we improve our customer’s process
                      efficiency, productivity, and end-product quality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cards Section */}
      <section id="services" className="services">
        <div className="container" data-aos="fade-up">
          <div className="section-title text-center">
            <h1 style={{ textTransform: "capitalize" }}>Paper & Pulp</h1>
          </div>
          <br />
          <div className="row md-12">
            {cards.map((card, index) => (
              <div
                className={`col-lg-4 col-md-${index % 2 === 0 ? "12" : "6"}`}
                data-aos="zoom-in"
                data-aos-delay={100 * (index % 3)}
                key={card.id}
              >
                <div className="icon-box">
                  <div className="icon-img">
                    <img src={card.image} alt={card.title} />
                  </div>
                  <div className="secton-title">
                    <h4>{card.title}</h4>
                  </div>
                  <p>{card.description}</p>
                  <br />
                  <a href={card.link || "#"} className="get-started-btn">
                    View Products
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default SPaper;
